import {
  Bar,
  BarChart,
  Cell,
  CartesianGrid,
  LabelList,
  ReferenceLine,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { MRR_GROWTH } from "./exampleData";
import {
  BORDER,
  CHART_NEGATIVE,
  CHART_POSITIVE,
  MUTED_FG,
  tooltipStyle,
  xAxisProps,
  yAxisProps,
} from "./chartTheme";
import MetricChartFrame from "./MetricChartFrame";

/**
 * MRR Growth Rate by month — the period-over-period percentage change in MRR.
 * Colored per bar by sign (a positive month green, a negative one red), with a
 * zero line so shrinking months stand out.
 */
const MrrGrowthRateChart = () => (
  <MetricChartFrame
    caption="Monthly MRR growth holds around 4–6% and eases as the base grows — the law of large numbers, not a stalling business. A negative month would mean churn and contraction outran new revenue."
    breakdown="No breakdown"
    active="6M"
  >
    <BarChart data={MRR_GROWTH} margin={{ top: 16, right: 8, left: 8, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={BORDER} vertical={false} />
      <XAxis dataKey="label" {...xAxisProps} />
      <YAxis tickFormatter={(v) => `${v}%`} width={44} {...yAxisProps} />
      <Tooltip
        cursor={{ fill: "hsl(var(--muted) / 0.4)" }}
        contentStyle={tooltipStyle}
        formatter={(value: number) => [`${value}%`, "MRR growth"]}
      />
      <ReferenceLine y={0} stroke={MUTED_FG} />
      <Bar dataKey="value" radius={[4, 4, 0, 0]} isAnimationActive={false}>
        <LabelList
          dataKey="value"
          position="top"
          formatter={(v: number) => `${v}%`}
          fontSize={11}
          fill={MUTED_FG}
        />
        {MRR_GROWTH.map((row) => (
          <Cell key={row.label} fill={row.value >= 0 ? CHART_POSITIVE : CHART_NEGATIVE} />
        ))}
      </Bar>
    </BarChart>
  </MetricChartFrame>
);

export default MrrGrowthRateChart;
